<template>
  <div class="project-setting">
    <div class="header-step">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'homeworkList' }">{{$t('homeworkManage.jobManagement')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'HomeworkInfo' }">{{$t('homeworkManage.newHomework')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('homeworkManage.jobSettings')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <ul class="tab">
      <li><div @click="handleTab('memoryBank')" :class="{ active : tabIndex === 'memoryBank' }">{{$t('newProjectV2.memoryBank')}}</div></li>
      <li><div @click="handleTab('termBank')" :class="{ active : tabIndex === 'termBank' }">{{$t('newProjectV2.termBank')}}</div></li>
      <li><div @click="handleTab('translationEngine')" :class="{ active : tabIndex === 'translationEngine' }">{{$t('newProjectV2.translationEngine')}}</div></li>
      <li><div @click="handleTab('preTranslation')" :class="{ active : tabIndex === 'preTranslation' }">{{$t('newProjectV2.preTranslation')}}</div></li>
      <li><div @click="handleTab('qualityAssurance')" :class="{ active : tabIndex === 'qualityAssurance' }">{{$t('newProjectV2.qualityAssurance')}}</div></li>
      <li><div @click="handleTab('punctuateRule')" :class="{ active : tabIndex === 'punctuateRule' }">{{$t('newProjectV2.punctuateRule')}}</div></li>
      <li><div @click="handleTab('otherSetting')" :class="{ active : tabIndex === 'otherSetting' }">{{$t('newProjectV2.other')}}</div></li>
    </ul>
    <div class="setting-content" :class="{ other : tabIndex === 'otherSetting' }">
      <keep-alive>
        <component :is="tabIndex"

          :memoryList="memoryList"
          :matchRate="matchRate"
          @matchRateChange="matchRateChange"
          @updateMemoryBank="updateMemoryBank"

          :termList="termList"
          :openTerm="openTerm"
          @changeTerm="changeTerm"

          :translationEngine="translationEngine"
          :translationEngineList="translationEngineList"
          @translationEngineChange="translationEngineChange"

          :preTransList="preTransList"
          @getPreTransList="getPreTransList"

          :openQa="openQa"
          :qualityList="qualityList"
          @handleOpenQA="handleOpenQA"
          @selAualityIDChange="selAualityIDChange"

          :ruleType="ruleType"
          :punctuateRuleList="punctuateRuleList"
          @getRuleID="getRuleID"
          @ruleTypeChange="ruleTypeChange"

          :docSetList="docSetList"
          :searchEngine="searchEngine"
          @searchEngineChange="searchEngineChange"

          @updateRule="updateRule"
        ></component>
      </keep-alive>
    </div>

    <div class="setting-button">
      <button @click="handlePreStep">{{$t('newProjectV2.previous')}}</button>
      <button class="primary" @click="handleSave">{{$t('newProjectV2.finish')}}</button>
      <button @click="goBack">{{$t('newProjectV2.cancel')}}</button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import memoryBank from './module/memoryBank';
import termBank from './module/termBank';
import translationEngine from './module/translationEngine';
import preTranslation from './module/preTranslation';
import qualityAssurance from './module/qualityAssurance';
import punctuateRule from './module/punctuateRule';
import otherSetting from './module/otherSetting';

import {
  querySelectableTermMemoryList,
  queryAllQuality,
  queryTranslationEngine,
  queryDocSet,
  queryAllPunctuateRule,
  saveProject,
  queryMemorySentCount,
  queryTermSentCount,
} from '@/services/newProjectApi';

export default {
  name: 'HomeworkSetting',
  components: {
    termBank,
    memoryBank,
    preTranslation,
    translationEngine,
    qualityAssurance,
    punctuateRule,
    otherSetting
  },
  data () {
    return {
      queryData: {},
      transModel: 1,
      tabIndex: 'memoryBank',

      memoryList: [],                     // 记忆库列表
      matchRate: 70,                      // 匹配率,

      termList: [],                       // 术语库列表
      openTerm: true,                     // 术语干预

      translationEngineList: [],          // 翻译引擎列表
      translationEngine: 'fanyu',         // 翻译引擎

      preTransList: {
        memoryBankModel: true,            // 用翻译记忆库进行预翻译
        machineModel: true,               // 用机器翻译进行预翻译
        memoryBankMatch: true,            // 100%翻译记忆库匹配
        lockRepeat: false,                 // 锁定重复
      },

      qualityList: [],                    // 质量列表
      openQa: true,                       // 开启QA
      qualitySelID: [],                   // 选择质量ID

      ruleType: 1,                        // 断句规则类型
      ruleID: null,                       // 断句规则ID
      punctuateRuleList: [],              // 断句规则列表

      searchEngine: 1,                    // 默认搜索引擎
      docSetList: [],                     // 文档设置列表

      timeOut: null,                      // 轮询使用

      // 切换团队不影响使用的companyCode
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
    };
  },
  mounted () {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    this.getMemoryAndTermList(this.queryData);
    this.getTranslationEngine();
    this.getAllQuality();
    this.getPunctuateRule();
    this.getDocList();
  },
  deactivated(){
    this.$destroy();
  },
  methods: {
    async updateMemoryBank (type) {
      await this.getMemoryAndTermList(this.queryData);
      this.tableOut(type);
    },
    tableOut (type) {
      let self = this;
      if (self.timeOut !== null) { return; }
      self.timeOut = window.setInterval(async () => {
        let list = [];

        if (type === 'memory') {
          list = self.memoryList;
        } else if (type === 'term') {
          list = self.termList;
        }

        let params = {
          idList: [],
        }

        list.forEach(item => {
          if (item.status > 1) {
            params.idList.push(item.id);
          }
        });

        if (params.idList.length < 1) {
          this.clear();
        } else {
          let resp = {};
          if (type === 'memory') {
            resp = await queryMemorySentCount(params);
          } else if (type === 'term') {
            resp = await queryTermSentCount(params);
          }
          let { success, result } = resp;
          if (success) {
            result.forEach(i => {
              list.forEach(item => {
                if (item.id === i.id) {
                  item.status = i.status;
                  item.sentCount = i.sentCount;
                }
              });
            });
          }
        }
      }, 2000);
    },
    clear() {
      if (this.timeOut === null) { return; }
      clearInterval(this.timeOut);
      this.timeOut = null;
    },
    handleSave: _.throttle(async function () {
      let self = this;
      // 记忆库列表
      let memoryBankArray = [];
      this.memoryList.forEach((item) => {
        if (item.isEnable) {
          memoryBankArray.push(item.id);
        }
      });

      // 术语库列表
      let termBankArray = [];
      this.termList.forEach(item => {
        if (item.isEnable) {
          termBankArray.push(item.id);
        }
      });

      // 上传文件列表
      let arr = [];
      this.queryData.fileList.forEach(item => {
        arr.push({
          ...item,
          transModel: this.transModel
        });
      });

      // 质量保证
      let qaList = [];
      this.qualitySelID.forEach(id => {
        this.qualityList.forEach(item => {
          if (id === item.id) {
            qaList.push({
              id: item.id,
              grade: item.grade,
              wordPercent: item.wordPercent,
            });
          }
        });
      });

      // 文档设置
      let documentSettingList = [];
      this.docSetList.forEach(item => {
        item.list.forEach(i => {
          if (i.isEnable) {
            documentSettingList.push(i.id);
          }
        });
      });

      // 翻译引擎
      let mtSupplierId = null;
      this.translationEngineList.forEach(item => {
        if (item.code === this.translationEngine) {
          mtSupplierId = item.id;
        }
      });

      let param = {
        name: this.queryData.name,
        memoryList: memoryBankArray,
        termList: termBankArray,
        domainCode: this.queryData.domainCode,
        sourceLang: this.queryData.sourceLang,
        targetLang: this.queryData.targetLang,
        transFileList: arr,
        langDesc: this.queryData.langDesc,
        projectProcessType: 1,
        deliveryTime: this.queryData.deliveryTime,
        ifRepeatLock: this.preTransList.lockRepeat ? 1 : 0,
        transModel: this.transModel,
        sourceType: 1,
        isTermIntervene: this.openTerm ? 1: 0,
        isPreMt: (this.preTransList.machineModel ? 1 : 0),
        memorySimilarPercent: this.matchRate,
        isOpenQa: (this.openQa ? 1 : 0),
        qaList: qaList,
        documentSettingList: documentSettingList,
        mtSupplierId: mtSupplierId,
        isAutoCommit: (this.preTransList.memoryBankMatch ? 1 : 0),
        isUseMemory: (this.preTransList.memoryBankModel ? 1 : 0),
        remark: this.queryData.remark,
        mtSearchId: this.searchEngine,

        companyCode: this.companyCode,
      }
      // 如果为自定义断句规则则传type
      if (this.ruleType === 2) {
        if (!this.ruleID) {
          this.$message.closeAll();
          this.$message.success(this.$t('newProjectV2.mustSelectedARules'));
          return;
        }
        param.segmentRuleId = this.ruleID;
      } else {
        param.isParagraph = this.ruleType;
      }
      let { success } = await saveProject(param);
      this.$message.closeAll();
      if (success) {
        this.$message.success(self.$t('newProjectV2.newSuccess'));
        this.$router.push({
          name: "homeworkList"
        });
      }
    }, 5000, {
      leading: true,
      trailing: false
    }),
    handlePreStep () {
      this.$router.go(-1);
    },
    goBack () {
      this.$router.push({
        name: "homeworkList"
      });
    },
    handleTab (index) {
      this.tabIndex = index;
      this.clear();
    },
    async getMemoryAndTermList (param) {
      let { success, result } = await querySelectableTermMemoryList({
        sourceLang: param.sourceLang,
        targetLang: param.targetLang
      });
      if (!success) { return; }
      result.transMemoryLibList.forEach(item => {
        item.isEnable = false;
      });
      result.transTermLibList.forEach(item => {
        item.isEnable = false;
      });
      this.memoryList = result.transMemoryLibList;
      this.termList = result.transTermLibList;
    },
    async getTranslationEngine () {
      let { result, success } = await queryTranslationEngine({});
      if (!success) { return; }
      this.translationEngineList = result;
    },
    async getAllQuality () {
      let { success, result } = await queryAllQuality({});
      if (!success) { return; }
      result.forEach((item, index)=> {
         //前五个默认为严重错误
         if (index < 5) {
          item.grade = 2
        } else {
          // 其他默认为一般错误
          item.grade = 1;
        }
        if (item.code === 'QA-T13' || item.code === 'QA-T14') {
          // 设置QA的百分比，默认百分之50
          item.wordPercent = 50;
        } else {
          item.wordPercent = 0;
        }
      });
      this.qualityList = result;
    },
    async getPunctuateRule () {
      let { success, result } = await queryAllPunctuateRule({
        sourceLang: this.queryData.sourceLang
      });
      if (!success) { return; }
      this.punctuateRuleList = result;
    },
    async getDocList () {
      let { success, result } = await queryDocSet({});
      if (!success) { return; }
      result.forEach(item => {
        item.isEnable = false;
        item.list.forEach(i => {
          i.isEnable = false;
        });
      });
      this.docSetList = result;
    },
    matchRateChange (val) {
      this.matchRate = val;
    },
    changeTerm (val) {
      this.openTerm = val;
    },
    translationEngineChange (val) {
      this.translationEngine = val;
    },
    getPreTransList (obj) {
      this.preTransList = obj;
    },
    selAualityIDChange (arr) {
      this.qualitySelID = arr;
    },
    handleOpenQA (val) {
      this.openQa = val;
    },
    searchEngineChange (val) {
      this.searchEngine = val;
    },
    ruleTypeChange (type) {
      this.ruleType = type;
    },
    getRuleID (ruleID) {
      this.ruleID = ruleID;
    },
    updateRule () {
      this.getPunctuateRule();
    },
  },
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>